import moment from "moment-jalaali";

const humanDate = (date: string, timeformat: string = "jYYYY-jM-jD") =>
  moment(date).locale("fa").format(timeformat);

export default humanDate;
